import React from 'react';
import './ContactGoogle.css';

function ContactGoogle() {
  return (
    <div className='contact-google-maps-outer'>
      <div className="contact-google-maps-inner">
        <iframe
          title="Client Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3563.3843764107055!2d88.41493227635378!3d26.73210747675525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e44124bcddf0dd%3A0x4a4364575a8f9e52!2sLIMS%20HOTEL%20MANAGEMENT%20INSTITUTE%2C%20SILIGURI%2C%20DARJEELING!5e0!3m2!1sen!2sin!4v1754983017865!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default ContactGoogle;
